
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { name: '首页', path: '/' },
    { name: '点滴公益', path: '/project' },
    { name: '我要认捐', path: '/donate' },
    { name: '申请帮助', path: '/apply' },
    { name: '公益公示', path: '/transparency' },
    { name: '志愿者招募', path: '/volunteer' },
    { name: '关于我们', path: '/about' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-md shadow-md' : 'bg-white/80 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-14 md:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 md:gap-3 group">
            <div className="w-9 h-9 md:w-12 md:h-12 flex items-center justify-center bg-gradient-to-br from-[#2A7A62] to-[#3A9A82] rounded-lg md:rounded-xl transition-transform group-hover:rotate-6">
              <i className="ri-water-flash-line text-white text-lg md:text-2xl"></i>
            </div>
            <span className="text-lg md:text-2xl font-bold text-[#2A7A62]">点滴公益</span>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center gap-12">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`relative text-base font-medium transition-colors cursor-pointer ${
                  location.pathname === item.path
                    ? 'text-[#2A7A62]'
                    : 'text-[#1E1E1E] hover:text-[#2A7A62]'
                }`}
              >
                {item.name}
                {location.pathname === item.path && (
                  <span className="absolute -bottom-2 left-0 right-0 h-0.5 bg-[#2A7A62] animate-[slideIn_0.3s_ease-out]"></span>
                )}
              </Link>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden w-9 h-9 flex items-center justify-center text-[#2A7A62] cursor-pointer"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-gradient-to-b from-[#2A7A62] to-[#1E5A4A] animate-[fadeIn_0.3s_ease-out]">
          <div className="px-4 py-6 space-y-3">
            {navItems.map((item, index) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className="block text-white text-base font-medium py-2.5 border-b border-white/20 cursor-pointer animate-[slideDown_0.3s_ease-out]"
                style={{ animationDelay: `${index * 0.05}s` }}
              >
                {item.name}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
